import { Box, Typography } from "@mui/material";
import { ReviewCardStyled } from "./review-card-patients.styles";
import { ReviewCardPatientsProps } from "./types";
import { Edit } from "@mui/icons-material";

const ReviewCardPatients: React.FC<ReviewCardPatientsProps> = ({
  patients,
  onEditClick,
}) => {
  return (
    <ReviewCardStyled>
      <div>
        {patients.map((data) => (
          <Box className="review-content">
            <Box className="title-and-sub-title">
              <Typography className="title">{data.name}</Typography>
              {data.content && (
                <Typography className="sub-title">{data.content}</Typography>
              )}
            </Box>
            <Typography className="reason">{data.reason}</Typography>
          </Box>
        ))}
      </div>
      <Box className="edit-button-container">
        <div className="edit-icon-wrapper" onClick={onEditClick}>
          <Edit />
        </div>
        <Typography onClick={onEditClick} className="edit-button">
          Edit
        </Typography>
      </Box>
    </ReviewCardStyled>
  );
};

export default ReviewCardPatients;
